export default __webpack_public_path__ + "static/media/car12.f616578a.jpg";